<template>
  <div>

    <!-- hola -->
    <component v-bind:is="type" :params="data" :from="from" :fromParams="fromParams" :query="query" :conf="configure"  v-if="ready"></component>
  </div>
    
</template>

<script>

import Vue from 'vue'


import nota from "@/components/public/note.vue";
import folder from "@/components/public/folder.vue";
import notas from "@/components/public/notas.vue";


export default {
  name: "publicLayout",
  props:['type','data','from','fromParams'],
  components:{nota,folder,notas},
  data () {
    return {
      url: this.$store.getters.getMainUrl,
      ready:false,
      query:{},
      configure:true
    }
  },
  /*beforeMount(){
    this.$store.commit('resetBackData');
  },*/
  created(){
    if(this.type == 'notas'){
      this.getQuery();
    }else{
      this.ready = true;
    }
  },
  methods:{
    getQuery:function(){
      
      var self = this;
      console.log(self.url )
      var post_data = {params : self.data}
      axios.post(self.url + "publicQuery", JSON.stringify(post_data))
      .then(response => {
        console.log("################==>>")
        console.log(response.data)
          if (response.data.success) {
            self.query = response.data.data.query;

              if(response.data.data.hasOwnProperty('config')){
                this.configure = response.data.data.config
              } 
            self.$store.commit('saveQuery',self.query);
            var ipid = response.data.data.ipid;
            self.$store.commit('setPublicUser',{ipid:ipid});
            self.ready=true;
          }else{
            console.log('error')
            console.log(response.data.error)
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
}

</script>